import styled from 'styled-components';

export const MyProfileWrap = styled.div`
  padding: 100px 0 0 0;
  @media screen and (max-width: 768px) {
    padding: 40px 0 0 0;
  }
`;

export const MyProfileWrapInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  @media screen and (max-width: 768px) {
    padding: 0px 24px;
  }
`;
export const MyProfileTitle = styled.div`
  margin-bottom: 32px;
  font-family: 'samsungsharpsans-bold';
  font-size: 32px;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 1.4;
  }
`;

export const MyProfileBox = styled.div`
  border-radius: 24px;
  background-color: #f6f6f6;
  @media screen and (max-width: 768px) {
    border-radius: 16px;
  }
`;

export const MyProfileTop = styled.div`
  display: flex;
  align-items: center;
  padding: 40px;
  @media screen and (max-width: 768px) {
    padding: 24px;
    border-radius: 16px;
  }
`;

export const MyProfileName = styled.div`
  font-family: 'SamsungOne-700';
  font-size: 24px;
  line-height: 1.35;
  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }
`;

export const MyProfileMail = styled.div`
  font-family: 'SamsungOne-600';
  font-size: 16px;
  line-height: 1.5;
  color: #7c7c7c;
  margin-top: 2px;

  @media screen and (max-width: 768px) {
    font-family: 'SamsungOne-400';
    font-size: 14px;
    line-height: 1.57;
    margin-top: 0;
    color: #7c7c7c;
  }
`;

export const MyProfileImg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin-right: 24px;
  border-radius: 100%;
  background-image: url(${`${process.env.PUBLIC_URL}/images/ico_myprofile.png`});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  img {
    display: block;
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }
`;
